<template>
  <div class="business-wrap">
    <div class="container">
      <div class="bus-top flex flex_content_sb">
        <div class="bus-left">
          <titleConfig
            :title="
              langSet == 'cn' ? '商机在线' : 'Business Opportunities Online'
            "
            :type="1"
          ></titleConfig>
          <div class="bus-text">
            {{
              langSet == "cn"
                ? "API制药家商机在线，365天全时间全空间实现商机互联！找原料、寻辅料、购包材、买设备尽在制药家商机在线！即刻点击，先人一步掌握无限商机！"
                : "API PharmHome’s “Business Opportunities Online” platform connects you to business opportunities 24/7! Find raw materials, excipients, packaging materials, and equipment, everything you need is just a click away. Stay ahead of the curve and seize unlimited opportunities now!"
            }}
          </div>
        </div>
        <div
          class="bus-right"
          :class="{ 'en-right': langSet != 'cn' }"
          @click="toLink('/product', '产品查询')"
        >
          <div class="bus-title flex flex_items_center flex_content_sb">
            {{ langSet == "cn" ? "产品查询" : "Products Search" }}
            <el-image
              style="width: 26px; height: 22px"
              :src="require('../../../assets/icon_bus.png')"
              :fit="'fill'"
            ></el-image>
          </div>
          <div class="bus-text" :class="{ 'bus-text-en': langSet != 'cn' }">
            {{
              langSet == "cn"
                ? "搜产品找样品，提前锁定目标供应商，让选品、采购更便捷、更高效！"
                : "Find products and samples, lock in target suppliers in advance, and make your sourcing more convenient and efficient!"
            }}
          </div>
        </div>
      </div>
      <div class="bus-right bus-search" @click="toLink('/company', '展商查询')">
        <div class="bus-title flex flex_items_center flex_content_sb">
          {{ langSet == "cn" ? "展商查询" : "Exhibitors Search" }}
          <el-image
            style="width: 26px; height: 22px"
            :src="require('../../../assets/icon_bus.png')"
            :fit="'fill'"
          ></el-image>
        </div>
        <div class="bus-text" :class="{ 'bus-text-en': langSet != 'cn' }">
          {{
            langSet == "cn"
              ? "药品研发至生产全链条供应商一键速查，随时制定参会日程！"
              : "Quickly find suppliers across the entire pharmaceutical R&D and production chain, and schedule your visit with ease!"
          }}
        </div>
      </div>
      <div
        class="bus-right bus-demand"
        @click="toLink('/business', '供需对接')"
      >
        <div class="bus-title flex flex_items_center flex_content_sb">
          {{ langSet == "cn" ? "供需对接" : "Supply-Demand Matchmaking" }}
          <el-image
            style="width: 26px; height: 22px"
            :src="require('../../../assets/icon_bus.png')"
            :fit="'fill'"
          ></el-image>
        </div>
        <div class="bus-text" :class="{ 'bus-text-en': langSet != 'cn' }">
          {{
            langSet == "cn"
              ? "一键发布供需，云上速配商机！"
              : "Post your supply or demand with one click, and match instantly with business opportunities in the cloud!"
          }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import titleConfig from "@/components/title.vue";
import { sdkClick } from "../../../sdk/useSdk";
export default {
  components: {
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      list: [],
    };
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    toLink(path, title) {
      sdkClick("首页功能区", title);
      this.$router.push({ path });
    },
  },
};
</script>
<style lang="scss" scoped>
.business-wrap {
  height: 888px;
  padding: 80px 0;
  box-sizing: border-box;
  overflow: hidden;
  background: #f9fafc;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 231px;
    height: 209px;
    background: url("../../../assets/bus_img.jpg") no-repeat;
    background-size: 100% 100%;
  }
  .container {
    position: relative;
    height: 100%;
    background: url("../../../assets/sj_bg.png") bottom left no-repeat;
    background-size: 52%;
  }
  .bus-top {
    height: 243px;
    .bus-left {
      width: 580px;
      .bus-text {
        font-size: 24px;
        color: #001a33;
        line-height: 40px;
        margin-top: 30px;
      }
    }
  }
}
.bus-right {
  width: 560px;
  height: 203px;
  margin-top: 10px;
  background: #fff;
  padding: 40px 55px 0 50px;
  box-sizing: border-box;
  box-shadow: 0px 5px 48px 0px rgba(0, 34, 99, 0.05);
  border-radius: 30px;
  cursor: pointer;
  .bus-title {
    color: #001a33;
    font-size: 30px;
    font-weight: 500;
    line-height: 42px;
  }
  .bus-text {
    width: 100%;
    font-size: 20px;
    color: #44435a;
    line-height: 32px;
    margin-top: 10px;
  }
  .bus-text-en {
    font-size: 17px;
    line-height: 28px;
  }
  &:hover {
    border: 1px solid #1d2379;
    .bus-title,
    .bus-text {
      color: #1d2379;
      transition: all 0.3s linear;
    }
  }
}
.bus-search {
  position: absolute;
  top: 243px;
  left: 580px;
}
.bus-demand {
  position: absolute;
  top: 476px;
  left: 490px;
}
@media only screen and (max-width: 1280px) {
  .business-wrap {
    height: 820px;
    padding: 70px 0;
  }
  .bus-right {
    transform: scale(0.9);
  }
  .bus-right {
    left: 430px;
  }
  .bus-demand {
    top: 486px;
    left: 350px;
  }
}
@media only screen and (max-width: 767px) {
  .business-wrap {
    height: 20.7rem;
    padding: 0.9rem 0;
    .container {
      background-position-y: 28%;
      background-size: 110%;
    }
    .bus-top {
      flex-wrap: wrap;
      .bus-left {
        width: 100%;
        .bus-text {
          font-size: 0.29rem;
          margin-top: 0.38rem;
          line-height: 0.46rem;
        }
      }
      .bus-right {
        width: 6.73rem;
        height: 2.85rem;
        margin-top: 5.69rem;
        border-radius: 20px;
      }
      .en-right {
        margin-top: 5rem;
      }
    }
    .bus-right {
      width: 6.73rem;
      height: 2.85rem;
      border-radius: 20px;
      padding: 0.58rem 0.38rem 0;
      .bus-title {
        font-size: 0.38rem;
        line-height: 0.54rem;
        .el-image {
          width: 0.5rem !important;
          height: 0.42rem !important;
        }
      }
      .bus-text {
        width: 5.38rem;
        font-size: 0.29rem;
        line-height: 0.46rem;
        margin-top: 0.23rem;
      }
    }
    .bus-search {
      left: 0;
      top: 11.2rem;
    }
    .bus-demand {
      left: 0;
      top: 14.4rem;
    }
  }
}
</style>